import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Form, Modal, Button, message, Spin, Checkbox } from 'antd';
import { PhoneOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { MaskedInput } from 'antd-mask-input';
import { QRCodeSVG } from 'qrcode.react';
import { userLoaded } from '../../redux/actions';
import { serverFetch } from '../../server';
import './auth.css';
import { getIsVkSession, getVkSession, hasNocookiesOptOut } from '../../extensions/utils';
import { useWindowWidth } from '@react-hook/window-size';

const Auth = ({ ...props }) => {
  const d = useDispatch();
  const { onClose } = props;
  const [form] = Form.useForm();
  const [authData, setAuthData] = useState({});
  const company = useSelector((s) => s.company);
  const user = useSelector((s) => s.user);
  const [logining, setLogining] = useState(false);
  const onlyWidth = useWindowWidth();
  const [intervaled, setIntervaled] = useState();
  const history = useHistory();
  const [page, setPage] = useState(0); // Страница: 0 - основная, 1 - ВК ожидание, 2 - телефон ожидание, 3 - вход по логину/паролю
  const [isRotating, setIsRotating] = useState(false);
  const [loading, setLoading] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [phoneCheckInterval, setPhoneCheckInterval] = useState(null);
  const [link, setLink] = useState();
  const [agreed, setAgreed] = useState(false);

  useEffect(() => user && onClose(), [user]);
  const getPhone = () => phoneNumber.replace(/\s/g, '');
  const isMobile = onlyWidth < 768;

  const escapeUrlParams = (urlString) => {
    try {
      const url = new URL(urlString);
      const params = new URLSearchParams(url.search);
      url.search = params.toString();
      return url.toString();
    } catch (e) {
      // Если URL некорректный, возвращаем как есть
      return urlString;
    }
  };

  useEffect(() => {
      form.resetFields();
      setPhoneNumber('');
      if (phoneCheckInterval) {
        clearInterval(phoneCheckInterval);
        setPhoneCheckInterval(null);
      }
  }, [form, phoneCheckInterval]);

  // Очистка интервала при размонтировании
  useEffect(() => {
    return () => {
      if (phoneCheckInterval) {
        clearInterval(phoneCheckInterval);
      }
    };
  }, [phoneCheckInterval]);

  const onValuesChange = (value) => {
    if (value.phone && !value.phone.startsWith('+7')) {
      const normalized = value.phone.replace(/^\+\d?/, '+7');
      form.setFieldValue('phone', normalized);
      setAuthData({ ...authData, phone: normalized });
      return;
    }

    setAuthData({ ...authData, ...value });
  };

  const isPhoneValid = phoneNumber && phoneNumber.indexOf('_') < 0 && phoneNumber.replace(/\s/g, '').length >= 12;

  const disableEnter = loading || !phoneNumber || phoneNumber.indexOf('_') >= 0;

  const startR = authCode => {
    const interval = setInterval(() => {
      serverFetch(`account/auth-check`, {
        method: 'GET',
        queryParams: { id: authCode }
      })
        .then((data) => {
          if (data) {
            clearInterval(interval);
            d(userLoaded(data));
            onClose();
          }
        })
        .catch(e => {
          console.log(`Ошибка ${e.UserMessage}`);
          // clearInterval(interval);
          // ChangePage(0);
        });
    }, 1000);
    setIntervaled(interval)
  }

  const isVkSession = getIsVkSession();
  const isNocookies = hasNocookiesOptOut();
  const AUTH_PHONE = '+79514002000';

  const copyAuthPhone = (e) => {
    e.preventDefault();
    if (!navigator.clipboard) {
      message.info(`Номер для звонка: ${AUTH_PHONE}`);
      return;
    }
    navigator.clipboard.writeText(AUTH_PHONE)
      .then(() => message.success('Номер скопирован. Откройте приложение «Телефон», вставьте номер и позвоните'))
      .catch(() => message.error('Не удалось скопировать номер'));
  };

  const openDeepLinkWithFallback = (deepLink) => {
    const timeout = 10000;

    const width = 800;
    const height = 300;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    const popup = window.open(deepLink, '_blank', `width=${width},height=${height},left=${left},top=${top}`);

    setTimeout(() => {
      if (popup && !popup.closed) popup.close();
    }, timeout);
  };

  const startMaxLogin = () => {
    setLoading(true);
    serverFetch(`account/auth-start`, {
      method: 'GET',
      queryParams: { providerVk: "max" }
    })
      .then(data => {
        ChangePage(1);
        startR(data.authCode);
        setLoading(false);
        // const width = 400;
        // const height = 600;
        // const left = window.innerWidth / 2 - width / 2;
        // const top = window.innerHeight / 2 - height / 2;
        // const _link = isMobile ? data.url : 
        const url = isNocookies && data.url
          ? data.url.replace('max://', 'https://max.ru/')
          : data.url;
        openDeepLinkWithFallback(url);
        // openDeepLinkWithFallback(data.url.replace('https://max.ru/', 'max://'));
        // window.open(data.url,'_blank', `width=${width},height=${height},left=${left},top=${top},noopener`);
        setLink(url);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.UserMessage);
      })
  }

  const startVkLogin = (provider) => {
    if (provider !== "vkid" && isVkSession) return;
    setLoading(true);
    if (isVkSession) {
      const bodyData = JSON.parse(atob(getVkSession()));
      serverFetch(`account/signinvk`, { method: 'POST', bodyData })
        .then(data => {
          d(userLoaded(data));
        })
        .catch(e => {
          setLoading(false);
          message.error('Ошибка входа. Попробуйте перегрузить страницу и предоставить доступ приложению до данных почты и телефона');
        });
    }
    else {
      serverFetch(`account/auth-start`, {
        method: 'GET',
        queryParams: { providerVk: provider }
      })
        .then(data => {
          ChangePage(1);
          startR(data.authCode);
          setLoading(false);
          const width = 400;
          const height = 600;
          const left = window.innerWidth / 2 - width / 2;
          const top = window.innerHeight / 2 - height / 2;
          window.open(data.url,'_blank', `width=${width},height=${height},left=${left},top=${top},noopener`);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.UserMessage);
        })
    }
  }

  const startPhoneLogin = () => {
    const cleanPhone = phoneNumber.replace(/\s/g, '');
    if (!cleanPhone || cleanPhone.indexOf('_') >= 0 || cleanPhone.length < 12) {
      message.warning('Пожалуйста, введите корректный номер телефона');
      return;
    }
    console.log(cleanPhone)
    ChangePage(2)
    serverFetch(`account/auth-start`, {
      method: 'GET',
      queryParams: { phone: cleanPhone }
    })
      .then(data => {
        ChangePage(2);
        startR(data.authCode);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.UserMessage);
      })
  }

  const onCancel = () => {
    setLogining(false);
    onClose ? onClose() : history.goBack();
    if (intervaled) clearInterval(intervaled);
    if (phoneCheckInterval) {
      clearInterval(phoneCheckInterval);
      setPhoneCheckInterval(null);
    }
  }

  const imgClassName = isVkSession ? 'auth-img-vk-disabled' : 'auth-img-vk-enabled';

  const ChangePage = value => {
    setIsRotating(true);
    setTimeout(() => {
      setPage(value);
      setTimeout(() => {setIsRotating(false);}, 50);
    }, 300);
  }

  const onLoginPassword = () => {
    setLoading(true);
    serverFetch("account/signin", { method: "POST", bodyData: { userLogin: getPhone(), password } })
      .then(data => d(userLoaded(data)))
      .catch(e => {
        setLoading(false);
        message.error(e.UserMessage);
      })
  }

  const getFormBody = () => {
    switch (page) {
      case 0:
        return <>
          <div className='auth-title'>Вход / Регистрация</div>
          <Form.Item>
            <Checkbox checked={agreed} onChange={e => setAgreed(e.target.checked)} style={{fontSize: 12}}>
              Согласен с обработкой конфиденциальных данных в соответствии с <a href='/article/agreement' target='_blank'>политикой конфиденциальности</a>
            </Checkbox>
            <div style={{ fontSize: 12, marginTop: 8, color: 'rgba(0, 0, 0, 0.45)', lineHeight: 1.5 }}>
              Авторизуйтесь, чтобы получить доступ к вашим покупкам и онлайн чекам
            </div>
          </Form.Item>
          <Form.Item label='Телефон'>
            <MaskedInput size='large' mask={'+7 000 000 00 00'} value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder='+7 ___ ___ __ __' type='tel' inputMode='tel' disabled={!agreed}/>
          </Form.Item>
          <Form.Item>
            <Button className='auth-btn' size='large' icon={<PhoneOutlined />} onClick={startPhoneLogin} disabled={!isPhoneValid || !agreed} block>Вход</Button>
          </Form.Item>
          <Form.Item className='auth-or'>или</Form.Item>
          {!isNocookies && <Form.Item>
            <div className='auth-btns-ss'>
              <img src='/images/vk.svg' className={agreed ? 'auth-img-vk-enabled' : 'auth-img-vk-disabled'} onClick={() => agreed && startVkLogin("vkid")} alt='vk'/>
              <img src='/images/ok.svg' className={agreed ? imgClassName : 'auth-img-vk-disabled'} onClick={() => agreed && startVkLogin("ok_ru")} alt='ok'/>
              <img src='/images/mail.svg' className={agreed ? imgClassName : 'auth-img-vk-disabled'} onClick={() => agreed && startVkLogin("mail_ru")} alt='mail'/>
              <img src='/images/max.svg' className={agreed ? imgClassName : 'auth-img-vk-disabled'} onClick={() => agreed && startMaxLogin()} alt='max'/>
            </div>
          </Form.Item>}
          {!isNocookies && company?.tgUrl && <Form.Item>
            <a href={agreed ? company?.tgUrl : undefined} target='_blank' rel="noreferrer" style={!agreed ? {pointerEvents: 'none', opacity: 0.4} : {}}>
              <div className='auth-or'><span>Открыть в Telegram</span><img src='/images/tg.svg' alt='tg' style={{width: 24}}/></div>
            </a></Form.Item>}
          <Form.Item>
          <div className='auth-or' onClick={() => agreed && ChangePage(3)} style={!agreed ? {opacity: 0.4, cursor: 'default'} : {}}>Войти по логину и паролю</div></Form.Item>
        </>
      case 1:
        return<>
          <div className='auth-title'>Ожидание авторизации...</div>
          <div className='auth-waiting'><Spin spinning/></div>
          {!isMobile && link && <div className='auth-qr'>
            <QRCodeSVG value={link} size={180} />
            <div>Отсканируйте код на телефоне с MAX</div>
            <a href={link} target='_blank'>Открыть в браузере</a>
          </div>}
        </>
      case 2:
        return<>
          <div className='phone-auth-waiting'>
            <div className='phone-auth-title'>Авторизация по телефону</div>
            <div className='phone-auth-instruction'>Для авторизации позвоните по телефону <a href={isNocookies ? '#' : `tel:${AUTH_PHONE}`} className='phone-auth-number' onClick={isNocookies ? copyAuthPhone : undefined}>+7 951 400 2000</a></div>
            {isNocookies && <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.45)', marginTop: 4 }}>Нажмите на номер, чтобы скопировать его</div>}
            <div className='phone-auth-client-phone'>Звонок ожидается с номера <b>{phoneNumber}</b></div>
            <div className='phone-auth-spinner'><Spin size="large" tip="Ожидание звонка..." /></div>
            <Form.Item><Button className='auth-btn' size='middle' icon={<ArrowLeftOutlined />} onClick={() => ChangePage(0)} block>Назад</Button></Form.Item>
          </div>
        </>
      case 3:
        return <>
          <div className='auth-title'>Вход</div>
          <Form.Item requiredMark='optional' label='Телефон'>
            <MaskedInput size='large' mask={'+7 000 000 00 00'} value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder='+7 ___ ___ __ __' 
              type='tel' inputMode='tel' disabled={loading} />
          </Form.Item>
          <Form.Item label='Код доступа'>
            <Input.Password size='middle' value={password} disabled={loading} onChange={e => setPassword(e.target.value)}/>
          </Form.Item>
          <Form.Item>
            <div className='btn-container-auth'>
              <Button className='auth-btn' size='middle' onClick={() => ChangePage(0)}  icon={<ArrowLeftOutlined/>} disabled={loading}>Назад</Button>
              <Button className='auth-btn' size='middle' disabled={disableEnter} onClick={onLoginPassword}>Войти</Button>
            </div>
          </Form.Item>
        </>
    }
  }

  return (
    <Modal forceRender open title={<div className='auth-close-btn'></div>} closable={true} footer={null} width={340} onCancel={onCancel} styles={{ margin: '-4px 20px 0'}} wrapClassName={isRotating ? 'auth-modal-rotating' : ''}>
      <Form colon={false} form={form} layout='vertical' onValuesChange={onValuesChange}>
        {getFormBody()}
      </Form>
    </Modal>
  );
};

export default Auth;
